module.exports = __webpack_public_path__ + "static/media/alert.fa468011.svg";